import { Injectable } from "@angular/core";
import { NetworkHierarchyServiceResourceService, JsonHierarchyElement } from "@psnb/nwt-api";
import { Observable } from "rxjs";
import { HierarchyNodeList } from "../models/hierarchy-node-List";

@Injectable({
  providedIn: 'root'
})
export class GetSystemHierarchyService {

  constructor(
    private getHierarchyService: NetworkHierarchyServiceResourceService
  ) { }

  /** Initial data */
  initialData(): HierarchyNodeList[] {
    const mockData: JsonHierarchyElement[] = [];
    mockData.push({
      altName: 'Organizational Root',
      elementID: 1,
      name: 'Organizational Root',
      hierarchyElementType: 'Group',
      elementParentID: 1
    });
    return mockData.map(name => new HierarchyNodeList(name, 0, true, false));
  }

  getChildren(node: JsonHierarchyElement): Observable<JsonHierarchyElement[]> | undefined {
    return this.getHierarchyService.resourceNetworkHierarchyServiceResourceGetHierarchyChildrenElementsGET(node.elementID);
  }

  isExpandable(node: JsonHierarchyElement): boolean {
    if (node.hierarchyElementType === 'NODE') {
      return false;
    }
    return true;
  }
}